import React from 'react'
// https://usehooks.com/usemediaquery
// https://github.com/uidotdev/usehooks/blob/main/index.js

export function useMediaQuery(query) {
  const subscribe = React.useCallback(
    callback => {
      const matchMedia = window.matchMedia(query)

      matchMedia.addEventListener('change', callback)
      return () => {
        matchMedia.removeEventListener('change', callback)
      }
    },
    [query],
  )

  const getSnapshot = () => {
    return window.matchMedia(query).matches
  }

  const getServerSnapshot = () => {
      // throw Error("useMediaQuery is a client-only hook");
      return false; // TODO: better default. This was a hack. https://stackoverflow.com/questions/76608501/error-usemediaquery-is-a-client-only-hook
  }

  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
